<div class="sp-dialog__max-width-s sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3 class="sp-color__primary sp-margin__bottom-x2">
      {{ 'COMPANIES.ENABLE_DISABLE_CTA' | translate }} {{ 'GENERAL.COMPANY_LABEL' | translate | lowercase }}:
    </h3>

    <form
      [formGroup]="company_enable_from_group"
      class="sp-column">
      <div class="sp-row">
        <mat-slide-toggle
          class="sp-margin__bottom-x2"
          formControlName="is_enabled"
          (change)="onToggleChange('is_enabled')">
          <p class="sp-color__primary sp-margin__left">{{ 'COMPANIES.ENABLE_DISABLE_CTA' | translate }}</p>
        </mat-slide-toggle>
        <mat-icon
          class="sp-color__accent sp-margin__left"
          matTooltip="{{ 'COMPANIES.ENABLE_DISABLE_TOOLTIP' | translate }}">
          info
        </mat-icon>
      </div>

      <div class="sp-row">
        <mat-slide-toggle
          class="sp-margin__bottom-x2"
          formControlName="is_partially_enabled"
          (change)="onToggleChange('is_partially_enabled')">
          <p class="sp-color__primary sp-margin__left">{{ 'COMPANIES.PARTIALLY_ENABLE_DISABLE_CTA' | translate }}</p>
        </mat-slide-toggle>
        <mat-icon
          class="sp-color__accent sp-margin__left"
          matTooltip="{{ 'COMPANIES.PARTIALLY_ENABLE_DISABLE_TOOLTIP' | translate }}">
          info
        </mat-icon>
      </div>

      <app-shared-button
        class="sp-width__full"
        [button_class]="'sp-button__main'"
        [spinner_class]="'sp-spinner__main'"
        [cta]="'GENERAL.CONFIRM_CTA'"
        [is_disabled]="is_enabling_running"
        [is_spinner_visible]="is_enabling_running"
        (click)="onConfirmClick()"></app-shared-button>
    </form>
  </div>
</div>
